// import { useState } from "react";
import { PricingPlan } from "./pricing-plan.types";
import PricingCard from "./PricingCard";

const pricingPlans: PricingPlan[] = [
  {
    name: 'Mensal',
    price: 'R$180',
    period: 'por mês',
    features: [
      'Gestão de pedidos',
      'Relatórios avançados',
      'Cardápio online',
      'Suporte prioritário',
      'Impressão de pedidos',
      // 'Controle de estoque por item do menu',
      'Contas a pagar e receber'
    ],
    buttonText: 'Começar Teste Grátis',
    featured: false,
    contactText: 'Olá, tenho interesse no sistema com plano mensal, quero mais detalhes sobre o Menu Master.'
  },
  {
    name: 'Trimestral',
    price: 'R$165',
    period: 'por mês',
    total: 'Plano por 3 meses',
    features: [
      'Gestão de pedidos',
      'Relatórios avançados',
      'Cardápio online',
      'Suporte prioritário',
      'Impressão de pedidos',
      // 'Controle de estoque por item do menu',
      'Contas a pagar e receber'
    ],
    buttonText: 'Começar Teste Grátis',
    featured: false,
    contactText: 'Olá, tenho interesse no sistema com plano trimestral, quero mais detalhes sobre o Menu Master.'
  },
  {
    name: 'Semestral',
    price: 'R$150',
    period: 'por mês',
    total: 'Plano por 6 meses',
    badge: 'Mais Popular',
    features: [
      'Gestão de pedidos',
      'Relatórios avançados',
      'Cardápio online',
      'Suporte prioritário',
      'Impressão de pedidos',
      // 'Controle de estoque por item do menu',
      'Contas a pagar e receber'
    ],
    buttonText: 'Começar Teste Grátis',
    featured: true,
    contactText: 'Olá, tenho interesse no sistema com plano Semestral, quero mais detalhes sobre o Menu Master.'
  },
  {
    name: 'Anual',
    price: 'R$120',
    period: 'por mês',
    total: 'Plano por 12 meses',
    // badge: 'Mais Popular',
    features: [
      'Gestão de pedidos',
      'Relatórios avançados',
      'Cardápio online',
      'Suporte prioritário',
      'Impressão de pedidos',
      // 'Controle de estoque por item do menu',
      'Contas a pagar e receber'
    ],
    buttonText: 'Começar Teste Grátis',
    featured: false,
    contactText: 'Olá, tenho interesse no sistema com plano anual, quero mais detalhes sobre o Menu Master.'
  },
  // {
  //   name: 'Empresarial',
  //   price: 'R$ 349',
  //   period: 'por mês',
  //   features: [
  //     'Usuários ilimitados',
  //     'Todas funcionalidades',
  //     'Integrações personalizadas',
  //     'Analytics avançados',
  //     'Suporte 24/7',
  //     'Múltiplas filiais',
  //     'API personalizada',
  //     'Consultoria especializada'
  //   ],
  //   buttonText: 'Falar com Vendas',
  //   featured: false
  // }
];

interface PrincingProps {
  scrollToSection: (sectionId: string, text?: string) => void;
}

const Pricing: React.FC<PrincingProps> = ({ scrollToSection }) => (
  <section id="precos" className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Planos e Preços</h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Escolha o plano ideal para o tamanho do seu negócio
        </p>
      </div>

      <div className="grid md:grid-cols-4 gap-5 max-w-5xl mx-auto">
        {pricingPlans.map((plan, index) => (
          <PricingCard key={index} plan={plan} index={index} scrollToSection={scrollToSection} />
        ))}
      </div>
    </div>
  </section>
);

export default Pricing;